/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_On_DoneInputs */

const en_push_on_done = /** @type {(inputs: Push_On_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications turned on for this device`)
};

/**
* | output |
* | --- |
* | "Notifications turned on for this device" |
*
* @param {Push_On_DoneInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const push_on_done = /** @type {((inputs?: Push_On_DoneInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_On_DoneInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_push_on_done(inputs)
});